module.exports = __webpack_public_path__ + "assets/img/tx267_3.88370b0c.jpg";